<template>
  <div class="home">
    <el-row>
      <el-col :span="10" :offset="14">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="16">
                <el-button @click="changeType(1)" :type="type == 1 ? 'primary' : 'default'">计划进度模拟</el-button>
                <el-button @click="changeType(2)" :type="type == 2 ? 'primary' : 'default'">实际进度模拟</el-button>
              </el-col>
              <el-col :span="8">
                <el-select filterable style="float: right" v-model="planName" placeholder="计划选择" @change="planChange">
                  <el-option v-for="item in options" :key="item.pjpl01" :label="item.pjpl03"
                    :value="item.pjpl01"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <div class="gantt_ot">
            <div class="gantt"></div>
          </div>
        </el-card>
        <el-card class="box-card" style="top: 15px">
          <el-row>
            <el-col :span="4">{{ startTime }}</el-col>
            <el-col :span="16">
              <el-progress :percentage="percentage" :color="customColor"></el-progress>
              <el-col :span="16">模拟时间：{{ thisTime }}</el-col>
            </el-col>
            <el-col :span="4">{{ endTime }}</el-col>
          </el-row>
          <el-row style="margin-top: 50px" v-show="isShow">
            <el-col :span="4" :offset="3">
              <el-button size="small" :type="btnStype[0]" @click="updataSpeed">速度</el-button>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button size="small" :type="btnStype[1]" @click="reSetplan">重置</el-button>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button size="small" :type="btnStype[2]" @click="stopPlan">暂停</el-button>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button size="small" :type="btnStype[3]" @click="planShcedule">播放</el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <!-- <h2>这是home.vue页面</h2> -->
    <div id="MyViewerDiv"></div>
  </div>
</template>

<script>
import { format, toJSON } from "@/tools/tool";
import {
  GetModelListByXid,
  GetModelLableList,
  GetPlanListNoJd,
  Get3DSimulate,
  GetPlanDetailTree,
} from "@/setAxios";
// import $ from "jquery";
export default {
  name: "simulationModel",
  components: {},
  data() {
    return {
      customColor: "#409eff",
      percentage: 0,
      days: "",
      startTime: "",
      endTime: "",
      tableData: [],
      planName: "",
      planName2: "",
      url: "",
      options: [],
      num: 0,
      setIn: null,
      Data: null,
      ziduan: 1,
      options2: [{ value: 1, label: "层级" }],
      dataspeed: 1,
      thisTime: "",
      btnStype: ["", "", "", ""],
      GanttChartData: [],
      GanttChartData2: [],
      isShow: true,
      originalData: null,
      type: 1, //1计划进度 2实际进度
      fullscreenLoading: null,
    };
  },
  methods: {
    changeType(data) {
      this.type = data;
      this.reSetplan();
    },
    // 获取进度任务详情树
    GetPlanDetailTree() {
      let params = {
        planId: this.planName,
      };
      GetPlanDetailTree({ params }).then((res) => {
        this.bianLi(res.Data);
        this.tableData = res.Data;
        this.GanttChartData.forEach((ele) => {
          let myColor = "";
          let desc1 = "";
          if (ele.State == "未启动（延期）") {
            myColor = "ganttWqdYq";
            desc1 = "未启动（延期）";
          } else if (ele.State == "未启动") {
            myColor = "ganttWqd";
            desc1 = "未启动";
          } else if (ele.State == "计划") {
            myColor = "ganttJh";
            desc1 = "计划";
          } else if (ele.State == "执行中") {
            myColor = "ganttZxz";
            desc1 = "执行中";
          } else if (ele.State == "已完成（延期）") {
            myColor = "ganttYwcYq";
            desc1 = "已完成（延期）";
          } else if (ele.State == "已完成") {
            myColor = "ganttYwc";
            desc1 = "已完成";
          } else if (ele.State == "已完成（提前）") {
            myColor = "ganttYwcTq";
            desc1 = "已完成（提前）";
          } else if (ele.State == "执行中（延期）") {
            myColor = "ganttZxzYq";
            desc1 = "执行中（延期）";
          }

          //计划进度
          this.GanttChartData2.push({
            name: ele.Name,
            desc:
              ele.CompletionSchedule == undefined
                ? ""
                : "完成度" + ele.CompletionSchedule + "%",
            values: [
              {
                from: ele.ks,
                to: ele.js,
                desc: desc1,
                label: ele.State == undefined ? "计划" : ele.State,
                customClass: ele.State == undefined ? "ganttJh" : myColor,
              },
            ],
          });
        });
        this.openGanttChart();
      });
    },
    bianLi(data) {
      data.forEach((ele) => {
        this.GanttChartData.push({
          ks: ele.pldt06,
          js: ele.pldt07,
          Name: ele.pldt04,
        });
        this.GanttChartData.push({
          ks: ele.pldt08 == null ? ele.pldt06 : ele.pldt08,
          js: ele.pldt09 == null ? new Date() : ele.pldt09,
          CompletionSchedule: ele.CompletionSchedule,
          Name: ele.pldt04,
          State: ele.State,
        });
        if (ele.children.length != 0) {
          this.bianLi(ele.children);
        }
      });
    },
    // 初始化甘特图
    openGanttChart() {
      $(".gantt").gantt({
        dow: ["一", "二", "三", "四", "五", "六", "天"],
        months: [
          "一月",
          "二月",
          "三月",
          "四月",
          "五月",
          "六月",
          "七月",
          "八月",
          "九月",
          "十月",
          "十一月",
          "十二月",
        ],
        source: this.GanttChartData2,
        waitText: "加载中，请等候",
        navigate: "scroll",
        scale: "days",
        maxScale: "months",
        minScale: "days",
        itemsPerPage: 20,
        cookieKey: "jquery.fn.gantt",

        onItemClick: function (data) {
          // 有数据范围内的点击事件
        },
        onAddClick: function (dt, rowId) {
          //无数据范围内的点击事件
        },
        onRender: function () {
          //渲染事件
          //
          if (window.console && typeof console.log === "function") {
            // console.log("chart rendered");
          }
        },
      });
    },
    updataSpeed() {
      this.btnStype = ["primary", "", "", ""];
      this.$prompt(
        "请输入一天对应秒数(当前：" + this.dataspeed + ")",
        "速度(最小值为0.01)",
        {
          inputType: "Number",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      ).then(({ value }) => {
        if (value) {
          if (value < 0.01) {
            this.$message.error("当前输入范围错误！");
          } else {
            this.dataspeed = value;
            this.reSetplan(1);
          }
        }
      });
    },
    reSetplan(type) {
      if (type != "1") this.btnStype = ["", "primary", "", ""];
      this.percentage = 0;
      clearInterval(this.setIn);
      this.setIn = null;
      this.num = 0;
      this.thisTime = this.startTime;
      EaBIM.resetSchedule(this.Data.type);
    },
    addDate(time) {
      //加一天
      var timestamp = Date.parse(new Date(time));
      timestamp += 1000 * 60 * 60 * 24; //加一天
      var newTime = new Date(timestamp).format("yyyy/MM/dd");
      return newTime;
    },
    stopPlan() {
      this.btnStype = ["", "", "primary", ""];
      clearInterval(this.setIn);
      this.setIn = null;
    },
    planShcedule() {
      this.btnStype = ["", "", "", "primary"];
      if (this.setIn) {
        return;
      }
      this.setIn = setInterval(() => {
        this.num++;
        this.thisTime = this.addDate(this.thisTime);
        if (this.num >= this.days) {
          clearInterval(this.setIn);
          this.setIn = null;
          this.percentage = 100;
          this.thisTime = new Date(this.endTime).format("yyyy/MM/dd");
        } else {
          this.percentage = Number(((this.num * 100) / this.days).toFixed(1));
        }
        this.originalData.forEach((element) => {
          if (this.type == 1 && element.days == this.num) {
            if (element.selectList.length > 0) {
              EaBIM.loadschedule(element.selectList, this.Data.type);
            }
          } else if (this.type == 2 && element.true_days == this.num) {
            if (element.selectList.length > 0) {
              EaBIM.loadschedule(element.selectList, this.Data.type);
            }
          }
        });
      }, 1000 * this.dataspeed);
    },
    planChange(data) {
      this.reSetplan();
      this.planName = data;
      this.options.forEach((ele) => {
        if (ele.pjpl01 == data) {
          this.planName2 = ele.pjpl03;
        }
      });
      this.GanttChartData = [];
      this.GanttChartData2 = [];
      this.GetPlanDetailTree();
      this.getData();
    },
    GetPlanListNoJd() {
      let params = {
        xid: localStorage.xid,
        userid: localStorage.id,
      };
      GetPlanListNoJd(params).then((res) => {
        this.options = res.Data;
        this.planName = res.Data[0].pjpl01;
        this.planName2 = res.Data[0].pjpl03;
        this.GetPlanDetailTree();
        this.getData();
      });
    },
    viewers(data) {
      EaBIM.localManyServerModelForSelects(data);
    },

    getData() {
      this.fullscreenLoading = this.$loading({
        lock: true,
        text: '数据处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {
        planid: this.planName,
      };
      Get3DSimulate(params).then((res) => {
        if (res.Data == null) {
          this.tableData = [];
          this.$message({
            type: "warning",
            message: "暂无模拟数据",
          });
          $("#MyViewerDiv").hide();
          this.isShow = false;
          return false;
        } else {
          this.isShow = true;
          $("#MyViewerDiv").show();
        }
        this.tableData = res.Data.list;
        this.originalData = res.Data.list;
        this.Data = res.Data;
        this.days = res.Data.days;
        this.endTime = new Date(res.Data.endTimeN).format("yyyy/MM/dd");
        this.startTime = new Date(res.Data.startTimeN).format("yyyy/MM/dd");
        this.thisTime = this.startTime;
        let d = {};
        d.models = res.Data.models;
        d.type = this.Data.type;
        this.viewers(d);
        this.fullscreenLoading.close();
      });
    },
  },
  created() {
    this.flushSession();
    this.GetPlanListNoJd();
  },
  mounted() {
    //this.viewers();
    document.oncontextmenu = function () {
      return false;
    };
  },
};
</script>

<style lang="less" scoped>
@import url("../../../../public/Content/css/style.css");

// .adsk-viewing-viewer .adsk-toolbar{
//   left: 50%;
// }
/deep/ .view {
  padding: 0;
}

#MyViewerDiv {
  height: 100%;
  top: 0;
  width: 58%;
  position: absolute;
  // float: left;
}

.home {
  // overflow: auto;
  // height: 100%;
  // position: relative;
}

// .aaa {
//   overflow: auto;
//   height: 5%;
//   position: absolute;
//   float: left;
//   // margin-top: 10px;
//   bottom: 0px;
//   width: 100%;
//   text-align: center;
//   // z-index: 2147483647;
//   .el-cascader {
//     margin: 3px 10px;
//   }
// }
.body_viewpoint .treeDemo_viewpoint {
  background: rgba(255, 255, 255, 0.8);
  width: 96%;
  height: 95%;
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 15px;
}

.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}

.liveBarCodeShow {
  z-index: 10;
  position: absolute;
  width: 410px;
  // background: #eee;
}

.search-input {
  width: 140px;
}

.back {
  background: #eee;
  max-height: 500px;
  overflow: auto;
}

.el-pagination {
  white-space: pre-wrap;
}

.gantt_ot {
  width: 102% !important;
  margin: 0px !important;
  max-height: 550px;
  overflow: auto;
}
</style>
